import React from 'react';
import { useUnits } from '../../../core/api';
import { UnitsGrid } from './UnitsGrid';
import { useTranslation } from '../../../core/hooks/useTranslation';

interface FeaturedUnitsInAreaProps {
    areaId: string;
    areaName: string;
}

export const FeaturedUnitsInArea: React.FC<FeaturedUnitsInAreaProps> = ({ areaId, areaName }) => {
    const { t } = useTranslation();

    const { data: unitsResponse, isLoading } = useUnits({
        areaId,
        limit: 4,
        occupied: false
    });

    const units = (unitsResponse as any) || [];

    if (isLoading) return <div className="animate-pulse h-96 bg-slate-100 rounded-lg" />;
    if (!units || units.length === 0) return null;

    return (
        <section className="mt-16 border-t border-slate-200 pt-16">
            <UnitsGrid
                units={units}
                title={t('areaFeaturedUnits.title', 'Available Units')}
                viewAllLink={`/search?location=${encodeURIComponent(areaName)}`}
            />
        </section>
    );
};
